import { type TranslateFunction } from './index'

export const translateLabels = <T extends { label: string; details?: string }>(
  items: T[],
  t: TranslateFunction
): T[] => {
  return items.map((item) => ({
    ...item,
    label: t(item.label),
    details: item.details ? t(item.details) : undefined,
  }))
}

export const translateTitles = <T extends { title: string }>(items: T[], t: TranslateFunction): T[] => {
  return items.map((item) => ({
    ...item,
    title: t(item.title),
  }))
}
